import { render, staticRenderFns } from "./EmployeeTagCreate.vue?vue&type=template&id=cd6e2998"
import script from "./EmployeeTagCreate.vue?vue&type=script&lang=js"
export * from "./EmployeeTagCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports